// frontend/src/components/ProtectedRoute.tsx
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Container, Alert, Spinner } from 'react-bootstrap';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requireApproval?: boolean;
  requireAdmin?: boolean;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ 
  children, 
  requireApproval = true,
  requireAdmin = false 
}) => {
  const { user, isAuthenticated, isApproved, canManageUsers, loading } = useAuth();

  if (loading) {
    return (
      <Container className="mt-5 text-center" style={{ direction: 'rtl', maxWidth: 480 }}>
        <Spinner animation="border" role="status" className="mb-3" />
        <p className="mb-1">מאמת התחברות…</p>
        <p className="text-muted small mb-0">
          אם נדרשת התחברות מחדש, תועבר אוטומטית לעמוד ההתחברות.
        </p>
      </Container>
    );
  }

  // אם לא מחובר - הפנה להתחברות
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // אם דרוש אישור ולא מאושר - הצג הודעה
  if (requireApproval && !isApproved) {
    return (
      <Container className="mt-5" style={{ direction: 'rtl' }}>
        <Alert variant="warning">
          <Alert.Heading>חשבונך ממתין לאישור</Alert.Heading>
          <p>
            החשבון שלך נרשם בהצלחה אך ממתין לאישור מנהל המערכת.
            אנא המתן עד שמנהל המערכת יאשר את החשבון שלך.
          </p>
          <hr />
          <p className="mb-0">
            <strong>שם משתמש:</strong> {user?.username}<br />
            <strong>אימייל:</strong> {user?.email}
          </p>
        </Alert>
      </Container>
    );
  }

  // אם דרוש מנהל ולא מנהל - הצג הודעה
  if (requireAdmin && !canManageUsers) {
    return (
      <Container className="mt-5" style={{ direction: 'rtl' }}>
        <Alert variant="danger">
          <Alert.Heading>אין הרשאת גישה</Alert.Heading>
          <p>עמוד זה מיועד למנהלים בלבד.</p>
        </Alert>
      </Container>
    );
  }

  return <>{children}</>;
};

export default ProtectedRoute;
